$(document).ready(function(){
Fancybox.bind("[data-fancybox]", {
  // Your custom options
  Thumbs: false,
});  
  
$(document).on("click", ".itg_play_button", function() {
  $('body').addClass("hidden_scroll");
  $(".overlay").css({"opacity": "1", "visibility": "visible"});
  var videoSrc = $(this).attr('data-video-src');
  var videoElement = $(this).closest('.itg_slider_section').find('.itg_slider_video video');
  videoElement.find('source').attr('src', videoSrc);
  videoElement[0].load();
  videoElement[0].play();
  $(this).closest('.itg_slider_section').find('.itg_slider_video').addClass('active');
});


  $(document).on("click keydown", ".itg-slide-clickable", function(e) {
    if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
    if (!swiper.allowClick && e.type === "click") return;
    if (!$(e.target).closest('.itg_play_button, .swiper-button-next, .swiper-button-prev').length) {
      if (e.type === "keydown") e.preventDefault();
      window.location.href = $(this).data('slide-url');
    }
  });

  $(document).on("click",".itg_slider_close,.itg_slider_img, .overlay",function() {
    $('body').removeClass("hidden_scroll");
    $(".overlay").css({"opacity": "0", "visibility": "hidden"});
    var videoElement = $(this).closest('.itg_slider_section').find('.itg_slider_video video');
    videoElement.find('source').attr('src', '');
    videoElement[0].pause();
    $(this).closest('.itg_slider_section').find('.itg_slider_video').removeClass('active');
  });
  
  function updateSliderTabIndex() {
    var $slider = $('.itg_slider_main');
    $slider.find('.swiper-slide.itg-slide-clickable').attr('tabindex', '-1');
    $slider.find('.swiper-slide .itg_banner_btn').attr('tabindex', '-1');
    var $active = $slider.find('.swiper-slide-active');
    if ($active.hasClass('itg-slide-clickable')) {
      $active.attr('tabindex', '0');
    }
    $active.find('.itg_banner_btn').attr('tabindex', '0');
  }

  $(document).on("keydown", ".itg_slider_section .swiper-button-next", function(e) {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); swiper.slideNext(); }
  });
  $(document).on("keydown", ".itg_slider_section .swiper-button-prev", function(e) {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); swiper.slidePrev(); }
  });

    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
      on: {
        init: updateSliderTabIndex,
        slideChangeTransitionEnd: updateSliderTabIndex
      }
    });
  

  /*faq js end*/
   $(".accordion__title_main").click(function(){
     
      $(this).parents('.accordion-content').siblings('.accordion-content').find('.accordion__content').slideUp('300');
      $(this).parents('.accordion-content').siblings('.accordion-content').find('.accordion__title_main .accordionIcon').removeClass('open')
      $(this).parents('.accordion-content').siblings('.accordion-content').find('.accordion__title_main .accordionIcon').addClass('close')
      $(this).parents('.accordion-content').siblings('.accordion-content').find('.accordion__title_main .accordionIcon').text('+')
     
      $(this).siblings('.accordion__content').slideToggle("300");
      
      if($(this).find('.accordionIcon').hasClass('close')){
        $(this).find('.accordionIcon').text('-')
        $(this).find('.accordionIcon').removeClass('close')
        $(this).find('.accordionIcon').addClass('open')
      }
      else if($(this).find('.accordionIcon').hasClass('open')){
        $(this).find('.accordionIcon').text('+')
        $(this).find('.accordionIcon').removeClass('open')
        $(this).find('.accordionIcon').addClass('close')
      }
  });
  /*faq js end*/
// on hover videos play start

$('.card__media .media video').each(function() {
  var video = $(this)[0]; 
  video.muted = true;

  $(video).on('mouseenter', function() {
    if (video.paused) {
      video.play().catch(function(error) {
        console.log("Play was prevented:", error);
      });
    }
  });

  $(video).on('click', function() {
    video.muted = false;
  });

  $(video).on('mouseleave', function() {
    video.pause();
    video.currentTime = 0;
  });
});

// on hover videos play end

// product page load js start
  
jQuery(document).on("click",".product .suggested_product .product-row .product-col",function() {
  
      var prodcut_handle = $(this).attr('data-handle');
      var prodcut_handlessss = $(this).attr('data-variant');
     // var productHandle = prodcut_handle+'?variant='+prodcut_handlessss;
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product").html('');
          var product_data = $(res).find('#itg_main_product').html();
          jQuery(document).find("#itg_main_product").html(product_data);
          window.location.reload();
        }
     });

setTimeout(function() {
  
const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', {
	direction: 'vertical',
	slidesPerView: 4.1, 
    loop:true,
	spaceBetween: 9,
	navigation: {
		nextEl: '.slider__next',
		prevEl: '.slider__prev'
	},
	freeMode: true,
	breakpoints: { 
		0: { 
			direction: 'horizontal', 
		},
		768: { 
			direction: 'vertical',
		}
	}
});
const sliderImages = new Swiper('.slider__images .swiper-container', { 
	direction: 'vertical', 
	slidesPerView: 1, 
    loop:true,
	mousewheel: true,
	navigation: {
		nextEl: '.slider__next',
		prevEl: '.slider__prev' 
	},
	grabCursor: true, 
	thumbs: { 
		swiper: sliderThumbs 
	},
	breakpoints: {
		0: { 
			direction: 'horizontal', 
		},
		768: {
			direction: 'horizontal', 
		}
	}
});

}, 1500);
    
});

// product page load js end

$(document).on("click", ".icon-col", function() {
  $('body').addClass("hidden_scroll");
  $(".img_text_overlay").css({"opacity": "1", "visibility": "visible"});
  var videoSrc = $(this).attr('data-video-src');
  var videoElement = $(this).closest('.full_width').find('.itg_slider_video video');
  videoElement.find('source').attr('src', videoSrc);
  videoElement[0].load();
  videoElement[0].play();
  $(this).closest('.full_width').find('.itg_slider_video').addClass('active');
});
  
$(document).on("click", ".img_text_itg_slider_close, .img_text_itg_slider_close, .img_text_overlay", function() {
  $('body').removeClass("hidden_scroll");
  $(".img_text_overlay").css({"opacity": "0", "visibility": "hidden"});
  var videoSrc = $(this).attr('data-video-src');
  var videoElement = $(this).closest('.full_width').find('.itg_slider_video video');
  videoElement.find('source').attr('src', '');
  // videoElement[0].load();
  videoElement[0].pause();
  $(this).closest('.full_width').find('.itg_slider_video').removeClass('active');
});

  setTimeout (function() {
        // $(document).find('.easysubwidgetboxselectionoptions ul li').siblings('li').removeClass('ItgActive');
        // $(document).find('.easysubwidgetboxselectionoptions ul li .checked').parents('li').addClass('ItgActive');
        $(document).find('.easyoptionlabel').removeClass('ItgActive');
        $(document).find('input[type="radio"]:checked').parents('.easyoptionlabel').addClass('ItgActive');
  },1500);


  $(document).on("click", ".easyoptionlabel", function() {
    setTimeout (function() {
        $(document).find('.easyoptionlabel').removeClass('ItgActive');
        $(document).find('input[type="radio"]:checked').parents('.easyoptionlabel').addClass('ItgActive');
    },100);
    
   var slected_value = $('.easyoptionlabel input[type="radio"]:checked').attr('data-purchase');
    if(slected_value == 'subscribe'){
      $('.product_subscription_display').addClass('active');
      $('.itg_subscription_delivery').addClass('active');
      $('.checked_input:first-child input[type="radio"]').prop('checked', true);
      var selectedval = $('.itg_subscription_delivery.active select').children("option:selected").attr('data-sellingval');
      $('.selling_value').val(selectedval);
    }else{
      $('.itg_subscription_delivery').removeClass('active');
      $('.product_subscription_display').removeClass('active');
      $('.selling_value').val();
      $(".checked_input input[type='radio']").prop('checked', false);
    }

    
    $(".itg_subscription_delivery.active select").change(function(){
        var selectedval = $(this).children("option:selected").attr('data-sellingval');
        $('.selling_value').val(selectedval);
    });
   
  });
// $(document).on("click", ".mile-high-club button.btn.button.button_delay", function() {
//   $(".klaviyo_popup.club_mile, .club_overlay").fadeIn("slow");
//   $("body").css("overflow","hidden");
// });
//   $(document).on("click", ".klaviyo_popup.club_mile span.close_popup_icon, .club_overlay", function() {
//   $(".klaviyo_popup.club_mile, .club_overlay").fadeOut("slow");
//     $("body").css("overflow","scroll");
// });
  
  $(document).on("click", ".mile-high-club button.btn.button.button_delay", function() {
  $(".klaviyo_popup.club_mile").fadeIn("slow");
});
  $(document).on("click", ".mile-high-club button.cancle_form", function() {
  $(".klaviyo_popup.club_mile").fadeOut("slow");
});

$(".checked_input select").change(function(){
  var selectvarient = $(this).children("option:selected").val();
  console.log(selectvarient);
  $(this).closest(".checked_input").find('input').prop('id', selectvarient);
});

 /*custom contact form js start*/
  // $('#DropdownVisibleTitle h2').text($('#Dropdown-Wrapper .Title h2').eq(0).text())
  $('#Dropdown-Content-Wrapper .Content').eq(0).fadeIn('slow');
  
  $('#DropdownVisibleTitle').click(function(){
    $('#Dropdown-Title-Wrapper').slideToggle('fast');
  })
  
  $('#Dropdown-Title-Wrapper .Title').click(function () {
    $('#DropdownVisibleTitle h2').text($(this).find('h2').text())
    $('#Dropdown-Title-Wrapper').hide()
    $(`#Dropdown-Content-Wrapper .Content:not([data-id=${$(this).attr('id')}])`).hide();
    $(`#Dropdown-Content-Wrapper .Content[data-id=${$(this).attr('id')}]`).fadeIn('20');
  })
  
  document.addEventListener('click',function (event) {
    if(event.target.closest('#Dropdown-Wrapper') || !document.getElementById('Dropdown-Title-Wrapper')) return;
    document.getElementById('Dropdown-Title-Wrapper').style.setProperty('display','none')
  })
  /*custom contact form js end*/
  
});


$(window).on('load', function() {
  SwymGrCheckSelling();
  SwymGrCheckDiscount();
});

$(document).on('change', '.itg_ctm_subscription [name="selling_plan"], .itg_subscription_delivery.active select', function () {
  SwymGrCheckSelling();  
});


const SwymGrCheckSelling = () => {
  setTimeout (function () {
    if  ($(document).find('.product .itg_ctm_subscription .itg_subscription_plane.easyoptionlabel.ItgActive').length) {
       var sellingID = $(document).find('.itg_subscription_plane.easyoptionlabel.ItgActive .itg_subscription_delivery.active select').val();
        //var sellingsId = '<input type="hidden" data-sls-selling_plan="" name="selling_plan" value="3367829663">';
        var sellingsId = '<input type="hidden" name="selling_plan" value="'+sellingID+'">';
        var discountLineItem = '<input id="FreeHatWithSubscription" type="hidden" name="properties[FreeHatWithSubscription]" value="Yes">';
        if ($(document).find('.product__info-container .product-form__buttons').find('[name="selling_plan"]').length) {
          $(document).find('.product__info-container .product-form__buttons').find('[name="selling_plan"]').remove();
           $(document).find('.product__info-container .product-form__buttons').find('#FreeHatWithSubscription').remove();
        }
        $(document).find('.product__info-container .product-form__buttons').append(sellingsId);
        $(document).find('.product__info-container .product-form__buttons').append(discountLineItem);
    } else {
        if ($(document).find('.product__info-container .product-form__buttons').find('[name="selling_plan"]').length) {
          $(document).find('.product__info-container .product-form__buttons').find('[name="selling_plan"]').remove();
           $(document).find('.product__info-container .product-form__buttons').find('#FreeHatWithSubscription').remove();
        }
    }
  }, 500);
}

const SwymGrCheckDiscount = () => {
  if ($(document).find('.SwymGrDiscountMultiple').length) {
    $.ajax({
      url: "/cart.json",
      dataType: "json",
      success: function(cartData) {
        var uniqueDiscountBundles = new Set();
         $.each(cartData.items, function(index, item) {
          if (item.properties.hasOwnProperty('FreeHatWithSubscription')) {
            uniqueDiscountBundles.add(item.properties.discount_bundle);
            $(document).find('.SwymGrDiscountMultiple').val('YP7261CNXSXA');
          } else {
            $(document).find('.SwymGrDiscountMultiple').val('123');
          }
        });
        // var concatenatedDiscountBundles = Array.from(uniqueDiscountBundles).join(',');
        // console.log("Discount Bundles:", concatenatedDiscountBundles);
        // concatenatedDiscountBundles = 'Largepalettediscount12-23Halfpans,Mediumpalettediscount12-23Halfpans,X-largepalettediscount12-23Halfpans'
      }
    });
  }
}

// art_basel.liquid count js

// day code
 document.addEventListener('DOMContentLoaded', function () {
const countdownEl = document.getElementById('countdown');
if (countdownEl) {
  const endDate = countdownEl.getAttribute('data-end-date');
  const endTime = new Date(endDate).getTime();

  function updateCountdown() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
          countdownEl.innerHTML = 'Time is up!';
          clearInterval(interval);
          return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      countdownEl.innerHTML = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
}
 });  


// Quick View Js start 
  $(document).on('click','.quick_view_itg ',function(){
    console.log('ssss')
    $('body.gradient').addClass('overflow_hide_cstm')
    $('.quick_view_products').addClass('active')
  let shopurl = $('body.gradient').attr('data-shop-url');
  let dataget =$(this).attr('data-url');
  let url = shopurl + '/products/'+ dataget
  console.log(url);
  $.ajax({
  url: url,
  dataType:"html", 
  success: function (data) { 
  var thisdata = $(data).find('#itg_main_product').html();
  $('.quick_view_data').empty().append(thisdata);
  if (typeof Swiper !== "undefined") {
  
  const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', {
  direction: 'vertical',
  slidesPerView: 4.1, 
  loop:true,
  spaceBetween: 9,
  navigation: {
  nextEl: '.slider__next',
  prevEl: '.slider__prev'
  },
  freeMode: true,
  breakpoints: { 
  0: { 
    direction: 'horizontal', 
  },
  768: { 
    direction: 'vertical',
  }
  }
  });
  const sliderImages = new Swiper('.slider__images .swiper-container', { 
  direction: 'vertical', 
  slidesPerView: 1, 
  loop:true,
  mousewheel: true,
  navigation: {
  nextEl: '.slider__next',
  prevEl: '.slider__prev' 
  },
  grabCursor: true, 
  thumbs: { 
  swiper: sliderThumbs 
  },
  breakpoints: {
  0: { 
    direction: 'horizontal', 
  },
  768: {
    direction: 'horizontal', 
  }
  }
  });
  
  }
  
  } 
  });
  })
$(document).on('click','.quick_view_products.active .close-btn ',function(){
    $('.quick_view_products').removeClass('active');
    $('body.gradient').removeClass('overflow_hide_cstm')
  // $('.quick_view_data').empty()
})


